import { tagged } from "@mirage/service-logging";

const logger = tagged("fss-dash-chat-local-storage");

export const localStorageHasInteractedWithFssDashChat =
  "hasInteractedWithFssDashChat";

export const localStorageGetHasInteractedWithFssDashChat = () => {
  try {
    const value = localStorage.getItem(
      localStorageHasInteractedWithFssDashChat,
    );
    return value === "true";
  } catch (error) {
    logger.error(
      "Error accessing localStorage for FSS Dash Chat interaction",
      error,
    );
    return false;
  }
};

export const localStorageSetHasInteractedWithFssDashChat = () => {
  try {
    localStorage.setItem(localStorageHasInteractedWithFssDashChat, "true");
  } catch (error) {
    logger.error(
      "Error setting localStorage for FSS Dash Chat interaction",
      error,
    );
  }
};
